import Api from '../global/api';

export function customersLoad () {
    return async dispatch => {

        // Loading
        dispatch({
            type: 'CUSTOMERS_LOAD',
            status: 'LOADING',
            payload: null
        })

        let active_profile = await Api.getLocal('_bvap');
        if(active_profile !== null){
            Api.req(`/customers/${active_profile}`, 'GET').then(
                res => {

                    Api.setLocal('customers', res.result);

                    dispatch({
                        type: 'CUSTOMERS_LOAD',
                        status: 'OK',
                        payload: res.result
                    })
                },
                err => {
                    // Login error
                    dispatch({
                        type: 'CUSTOMERS_LOAD',
                        status: 'error',
                        payload: typeof err.msg === 'string' ? err.msg : 'Sorry we were unable to load your customers'
                    })
                }
            )
        }

    }
}

export function customerAdd (payload) {
    return dispatch => {

        // Loading
        dispatch({
            type: 'CUSTOMER_ADD',
            status: 'OK',
            payload: payload
        })

        return 'success';

    }
}

export function customerUpdate (payload) {
    return async dispatch => {

        // Loading
        dispatch({
            type: 'CUSTOMER_UPDATE',
            status: 'OK',
            payload: payload
        })
        
    }
}

export function customerUpdateBalance (payload) {
    return async dispatch => {

        // Loading
        dispatch({
            type: 'CUSTOMER_UPDATE_BALANCE',
            status: 'OK',
            payload: payload
        })
        
    }
}